export default __webpack_public_path__ + "a9c84d0484feb56bab452fbe9f3b5062.png";